import type { ReactElement } from 'react';

import { BpkVessel } from '@skyscanner-internal/backpack-web/bpk-component-layout';

import { PAGE_FLOW } from '../../constants';
import { SOURCES } from '../../constants/tracking';

import type { PageFlow, Source } from '../../types';

import STYLES from './FeatureImage.module.scss';

const LOGIN_FEATURE_IMAGE_URL =
  'https://content.skyscnr.com/m/4d4722ce007439fc/original/Log-in-Image.jpg?resize=918px:972px&quality=60';

const LOGIN_MARKETING_CONSENT_IMAGE_URL =
  'https://content.skyscnr.com/m/5358e219dddb3352/original/Opt-In-Image.jpg?imbypass=true';

// Trip-builder login (source: TRIP) uses the same image as CreateTripModal
// (@skyscanner-internal/global-components/unstable__create-trip-modal).
const TRIP_FEATURE_IMAGE_URL =
  'https://content.skyscnr.com/asset/fb6a0301-a27c-4c08-99f5-6e4dd9d8be8e/david-becker-1cf_Og9eC0k-unsplash.jpg?imbypass=true';

const getImageSrc = (source: Source, step: PageFlow): string => {
  if (source === SOURCES.TRIP) {
    return TRIP_FEATURE_IMAGE_URL;
  }

  return step === PAGE_FLOW.MARKETING_CONSENT
    ? LOGIN_MARKETING_CONSENT_IMAGE_URL
    : LOGIN_FEATURE_IMAGE_URL;
};

/*
 * A plain <img> tag is used here instead of BpkImage/BpkBackgroundImage because
 * the Backpack image components are designed around an `aspectRatio` prop that
 * uses `paddingBottom` to maintain a fixed ratio. Our use case requires the image
 * to fill its grid cell dynamically (100% width and height) with `object-fit: cover`,
 * which conflicts with that aspect-ratio approach.
 */
const FeatureImage = ({ source, step }: { source: Source; step: PageFlow }): ReactElement => {
  const src = getImageSrc(source, step);

  return (
    <BpkVessel className={STYLES['feature-image-wrap']}>
      <img className={STYLES['feature-image']} src={src} alt="" role="presentation" />
    </BpkVessel>
  );
};

export default FeatureImage;
